import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';

import bokeh from '../../images/bokeh.jpg';

const Header = () => {
    return (
        <Box
            minHeight='60vh'
            width='100%'
            sx={{
                backgroundImage: `url(${bokeh})`,
                backgroundSize: 'cover',
                backgroundPosition: 'top',
                display: 'grid',
                placeItems: 'center',
            }}
        >
            <Container>
                <Grid
                    container
                    item
                    xs={12}
                    lg={7}
                    justifyContent='center'
                    mx='auto'
                >
                    <Typography
                        variant='h3'
                        component={'h1'}
                        color='white'
                        mt={-6}
                        mb={1}
                    >
                        Mon app React{' '}
                    </Typography>
                    <Typography
                        variant='body1'
                        color='white'
                        textAlign='center'
                        px={{ xs: 6, lg: 12 }}
                        mt={1}
                    >
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Pellentesque a fringilla ante, sit amet dapibus.
                    </Typography>
                </Grid>
            </Container>
        </Box>
    );
};

export default Header;
